import React, { useEffect } from 'react';
import { Timeline, TimelineItem } from 'vertical-timeline-component-for-react';
import clickSignLogo from '~/Images/clickSignLogo.svg';
import d4SignLogo from '~/Images/d4SignLogo.png';
import { format } from '~/Utils/Helpers';
import { CorEventoDocDigital, DATETIME_DEFAULT_FORMAT } from '~/constant';
import { URL_BASE } from '~/constant';

const HistoricoDocumentoDigital = ({ documento, plataforma }) => {
  return (
    <section className="my-2">
      <h5>Histórico</h5>
      {documento.log.length === 0 && (
        <p>
          Histórico ainda não disponível, esta é uma nova solicitação de
          assinatura digital
        </p>
      )}
      <Timeline lineColor={'#ddd'} animate className="ml-auto">
        {documento.log.map((el, index) => {
          const corEvento = CorEventoDocDigital.find(
            t => t.value === el.evento
          );
          const cor = corEvento ? corEvento.color : '#C4C4C4';

          return (
            <TimelineItem
              key={index}
              dateText={format.date(el.data, DATETIME_DEFAULT_FORMAT)}
              dateInnerStyle={{
                background: cor,
              }}
              style={{
                color: cor,
              }}
            >
              <>
                <h5>{el.descricao_evento}</h5>
                <p className="text-muted">{el.usuario.nome}</p>
                <p>{el.observacao}</p>
                {el.origem_remota && plataforma === 'clicksign' && (
                  <img
                    alt="logo ClickSign"
                    style={{
                      width: 60,
                      position: 'absolute',
                      top: 0,
                      left: 240,
                    }}
                    src={clickSignLogo}
                  />
                )}
                {el.origem_remota && plataforma !== 'clicksign' && (
                  <img
                    alt="logo D4Sign"
                    style={{
                      width: 100,
                      position: 'absolute',
                      top: 0,
                      left: 200,
                    }}
                    src={d4SignLogo}
                  />
                )}
              </>
            </TimelineItem>
          );
        })}
      </Timeline>
      <div className="container my-5">
        <div className="row">
          {documento &&
            documento.log_extra &&
            documento.log_extra.length > 0 &&
            documento.log_extra.map((item, index) => (
              <div className="col-md-4 mb-4" key={index}>
                <div className="card shadow-sm">
                  <div className="card-body">
                    <h5 className="card-title">{item.codigo_doc_digital}</h5>
                    <p className="card-text">
                      <strong>Status:</strong> {item.status_string}
                    </p>
                    <p className="card-text">
                      <strong>Tipo:</strong> {item.tipo_string}
                    </p>
                    <div className="d-flex justify-content-between">
                      <a
                        href={`${URL_BASE}/documentodigital?codDocDigital=${item.codigo_doc_digital}`}
                        target="_blank"
                        rel="noopener noreferrer"
                        className="btn btn-primary btn-sm"
                      >
                        Ver Documento
                      </a>
                    </div>
                  </div>
                </div>
              </div>
            ))}
        </div>
      </div>
    </section>
  );
};

export default HistoricoDocumentoDigital;
